export class FilterModel {
  filtername: string;
  availablevalues: string[];
  selectedvalue: string;
  constructor() {
    this.availablevalues = [];
  }

}



// WEBPACK FOOTER //
// ./src/app/product-category/models/filter.model.ts